/**
 * Strips the characters Windows rejects in file names.
 *
 * A name kept inside an archive is never sanitized by the browser, so an entry such as
 * "2026-06-26T23:10:03.015Z.csv" cannot be extracted at all and the download looks
 * corrupted.
 */
export function sanitizeFileName(name: string): string {
  const safe = name
    .replace(/[<>:"\\/|?*]/g, "-")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^[-.]+|[-.]+$/g, "");
  return safe || "export";
}

/**
 * Triggers a browser download for an in-memory blob.
 *
 * The anchor must be attached to the document and the object URL must outlive the
 * click: a detached anchor is ignored by Firefox, and revoking the URL in the same
 * tick cancels the download before it starts.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
